import { useCallback } from 'react';
import { ChargeDto, UpdatePlanChargeRequestDto } from '@tiendanube/common';
import { toStatusType } from 'App/rtk';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { usePatchUpdatePlanChargeMutation } from '../CheckoutApi';
import { useChargeCreation } from '../pages/PlansAndSubscriptions/components/PaymentsTabs/components/SelectChargesToPayTab/hooks';

function useUpdateCharge(fixedCacheKey?: string) {
  const { resolveVirtualChargeCreation } = useChargeCreation();
  const [updateCharge, { status }] = usePatchUpdatePlanChargeMutation({
    fixedCacheKey,
  });

  const resolveVirtualChargeAndUpdate = useCallback(
    async (charge: ChargeDto, updateData: UpdatePlanChargeRequestDto) => {
      await resolveVirtualChargeCreation(charge);
      await updateCharge(updateData).unwrap();
    },
    [resolveVirtualChargeCreation, updateCharge],
  );

  return {
    updateCharge,
    resolveVirtualChargeAndUpdate,
    status: toStatusType(status),
    ...convertStatusTypeToObject(status),
  };
}

export default useUpdateCharge;
